/** Dynamics GUIDs are case-insensitive; normalize for API and WebSocket paths. */
export function normalizeDynamicsGuid(id: string): string {
  return id.toLowerCase();
}
